import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { Route, Routes } from 'react-router-dom';

import { Values } from './data';
import { StartStep } from './StartStep';
import { SuccessStep } from './SuccessStep';
import { VerifyStep } from './VerifyStep';

import { SmsDeliveryMethods } from '../../Shared/data';
import urlBuilder from '../../Shared/url-builder';

const Controller: React.FC = () => {
  const settingsUrl = urlBuilder.getSettings();

  const initialValues: Values = {
    phoneNumber: '',
    code: '',
    deliveryMethod: SmsDeliveryMethods.sms,
  };

  return (
    <FlowContextProvider returnToPath={settingsUrl} initialValues={initialValues}>
      <Routes>
        <Route
          path="/start"
          element={<StepWrapper name="start">{stepProps => <StartStep {...stepProps} />}</StepWrapper>}
        />
        <Route
          path="/verify"
          element={<StepWrapper name="verify">{stepProps => <VerifyStep {...stepProps} />}</StepWrapper>}
        />
        <Route
          path="/success"
          element={<StepWrapper name="success">{stepProps => <SuccessStep {...stepProps} />}</StepWrapper>}
        />
      </Routes>
    </FlowContextProvider>
  );
};

export default Controller;
